import { OrderProfile } from '../types';
import { IOrderProfileService } from './IOrderProfileService';
import { logger } from '@common/logging/logger';

export class OrderProfileServiceExceptionDecorator implements IOrderProfileService {
  private decoree: IOrderProfileService;

  constructor(decoree: IOrderProfileService) {
    this.decoree = decoree;
  }

  getOrderProfile(): OrderProfile | null {
    try {
      return this.decoree.getOrderProfile();
    } catch (err) {
      this.logError('getOrderProfile', err);
      return null;
    }
  }

  setPanelOpen(value: boolean): void {
    try {
      this.decoree.setPanelOpen(value);
    } catch (err) {
      this.logError('setPanelOpen', err);
    }
  }

  setOrderProfile(orderProfile: OrderProfile): void {
    try {
      this.decoree.setOrderProfile(orderProfile);
    } catch (err) {
      this.logError('setOrderProfile', err);
    }
  }

  private logError(methodName: string, error: unknown): void {
    logger.error(`OrderProfileService.${methodName} failed:`, error);
  }
}
